/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-02-25T09:40:19.469
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentHouseTypePic,
	listRentHouseTypePicInit,
	listRentHouseTypePicByAuthorizations,
	deleteRentHouseTypePic
	
} from '@api/rentmanage/RentHouseTypePic';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentHouseTypePic({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseTypePic(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseTypePicByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseTypePicByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseTypePicInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseTypePicInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentHouseTypePic({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseTypePic({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
